var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { KS } from './ks';
import { PrimoPlus } from './primoPlus';
import { NK } from './nk';
import { NKSelectS } from './nkSelectS';
import { NKSelectL } from './nkSelectL';
import { NKSelectXL } from './nkSelectXl';
import { Primo } from './primo';
import { HiMedical } from './hiMedical';
import { HiMedicalPlus } from './hiMedicalPlus';
export var priceMatrix = NK.map(function (a, i) { return (__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, a), KS[i]), Primo[i]), PrimoPlus[i]), HiMedical[i]), HiMedicalPlus[i]), NKSelectS[i]), NKSelectL[i]), NKSelectXL[i]), { 'NLTN.': { '0': 0, '1200': 0, '300': 0, '600': 0 } })); });
export var tariffNameMapping = {
    NK: 'Premium',
    NKSelectS: 'Standard',
    NKSelectL: 'Plus',
    NKSelectXL: 'Premium',
    KS: 'Standard',
    Primo: 'Standard',
    PrimoPlus: 'Standard Plus',
    HiMedical: 'Standard',
    HiMedicalPlus: 'Premium',
    'NLTN.': 'Emergency',
};
export var tariffLongNameMapping = {
    NK: 'Premium',
    NKSelectS: 'Standard',
    NKSelectL: 'Plus',
    NKSelectXL: 'Premium',
    KS: 'Standard',
    Primo: 'Standard',
    PrimoPlus: 'Standard Plus',
    HiMedical: 'Standard short-term',
    HiMedicalPlus: 'Premium short-term',
    'NLTN.': 'Emergency coverage',
};
